import React, {useState} from 'react';
import NewsLetter from '../../Images/icon-newsletter.png';
import Logo from '../../Images/logoo.png';
import {GoLocation} from 'react-icons/go';
import {BiMobileAlt} from 'react-icons/bi';
import {AiOutlineMail} from 'react-icons/ai';
import { toast } from 'react-toastify';
import { Global } from '../Variables/Global';
import {GrFacebookOption} from 'react-icons/gr';
import {FaInstagram} from 'react-icons/fa';


const FooterAR = () => {
    const [emailNewsLetter, setEmailNewsLetter] = useState("");
	var emailregx = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
	  function isValid() {
			if (emailNewsLetter === "") {
			  toast.error("please Provide your Email");
			  return false;
			} else if (!emailregx.test(emailNewsLetter)){
			  toast.error("Bad email format");
			}else {
			  return true;
			}
		   
		}

	const HandleSubscribe = (e) => {
        e.preventDefault();
       if(isValid()){
        fetch(Global.API_URL + "NewsLetter/SubscribeToNewsLetter" , {
            method: "POST",
            headers: {
              Accept: "application/json",
              "Content-Type": "application/json",
              "Access-Control-Allow-Origin": Global.API_URL,
            },
            body: JSON.stringify({
              Email: emailNewsLetter,
            }),
          })
            .then((response) => {
              if (response.ok) {
                toast.success("Subscribed Successfully");
                return response.json();
              }
              return response.text().then((text) => {
                throw new Error(text);
              });
            })
       }
    }
  return (
    <>
      <footer>
        {/* <!--=======  newsletter section  =======--> */}

        <div className="newsletter-section pt-5 pb-5 ">
            <div className="container ">
                <div className="row d-flex flex-row-reverse ">
                    <div className="col-lg-4 col-md-12 col-sm-12 mb-sm-2 mb-xs-2">
                        {/* <!--=======  newsletter title =======--> */}

                        <div className="newsletter-title float-sm-end">
                            <h1>
                                <img width="37" height="28" src={NewsLetter} alt="OssaKbire Newsletter" />
                                الإشتراك بآخر الأخبار
                            </h1>
                        </div>

                        {/* <!--=======  End of newsletter title  =======--> */}
                    </div>

                    <div className="col-lg-8 col-md-12 col-sm-12">
                        {/* <!--=======  subscription-form wrapper  =======--> */}

                        <div className="subscription-form-wrapper d-flex flex-wrap flex-sm-nowrap flex-row-reverse ">
                            <p className="mb-xs-2 directionRtl">إشترك في النشرة الإخبارية كي يصلك منا كل جديد</p>
                            <div className="subscription-form">
                                <form onSubmit={HandleSubscribe}>

                                    <button id="mc-submit" type="submit"> إشترك</button>

                                    <input type="email" id="mc-email" autoComplete="off" className="directionRtl"
                                        placeholder="البريد الإلكتروني" onChange={(e) => setEmailNewsLetter(e.target.value)} />
                                </form>

                                {/* <!-- mailchimp-alerts Start --> */}
                                <div className="mailchimp-alerts">
                                    <div className="mailchimp-submitting"></div>
                                    <div className="mailchimp-success"></div>
                                    <div className="mailchimp-error"></div>
                                </div>
                            </div>
                        </div>

                        {/* <!--=======  End of subscription-form wrapper  =======--> */}
                    </div>
                </div>
            </div>
        </div>

        {/* <!--=======  End of newsletter section  =======--> */}

        {/* <!--=======  social contact section  =======--> */}

        <div className="social-contact-section pt-5 pb-5">
            <div className="container">
                <div className="row flex-row-reverse">
                    <div className="col-lg-4 col-md-12 order-2 order-md-2 order-sm-2 order-lg-1">
                        {/* <!--=======  social media links  =======--> */}

                        <div className="social-media-section">
                            <h2 className="directionRtl">تابعنا</h2>
                            <div className="social-linksArabic">
                                <a className="facebook" href="https://www.facebook.com/ossakbireuae" data-tooltip="Facebook">
                                    {/* <i className="fa fa-facebook"></i> */}
                                    <GrFacebookOption />
                                </a>
                               <a className="instagram" href="https://www.instagram.com/ossakbireuae/" data-tooltip="Instagram">
                                        {/* <i className="fa fa-instagram"></i> */}
                                        <FaInstagram />
                                </a>
                                {/* <!-- <a class="twitter" href="http://www.twitter.com" data-tooltip="Twitter"><i
                                        class="fa fa-twitter"></i></a>
                                <a class="instagram" href="http://www.instagram.com" data-tooltip="Instagram"><i
                                        class="fa fa-instagram"></i></a>
                                <a class="linkedin" href="http://www.linkedin.com" data-tooltip="Linkedin"><i
                                        class="fa fa-linkedin"></i></a>
                                <a class="rss" href="http://www.rss.com" data-tooltip="RSS"><i
                                        class="fa fa-rss"></i></a> --> */}
                            </div>
                        </div>

                        {/* <!--=======  End of social media links  =======--> */}

                    </div>
                    <div className="col-lg-8 col-md-12 order-1 order-md-1 order-sm-1 order-lg-2  mb-sm-5 mb-xs-5">
                        {/* <!--=======  contact summery  =======--> */}

                        <div className="contact-summery">
                            <h2 className="directionRtl">تواصل معنا</h2>

                            {/* <!--=======  contact segments  =======--> */}

                            <div
                                className="contact-segments d-flex justify-content-between flex-wrap flex-lg-nowrap flex-row-reverse ">
                                {/* <!--=======  single contact  =======--> */}

                                <div className="single-contact d-flex mb-xs-2 flex-row-reverse">
                                    <div className="icon">
                                        {/* <span className="icon_pin_alt"></span> */}
                                        <GoLocation />
                                    </div>
                                    <div className="directionRtl">
                                        <div className="contact-info">
                                            <p>العنوان:<span>الإمارات-دبي</span></p>
                                        </div>
                                    </div>

                                </div>

                                {/* <!--=======  End of single contact  =======-->
                                <!--=======  single contact  =======--> */}

                                <div className="single-contact d-flex mb-xs-2 flex-row-reverse ">
                                    <div className="icon">
                                        {/* <span className="icon_mobile"></span> */}
                                        <BiMobileAlt />
                                    </div>
                                    <div >
                                        <div className="contact-info">
                                            <p className='directionRtl'>الهاتف:<br/> <a className='RemUnderlineFH' href="tel:+971505797151" style={{ direction: 'ltr'}} ><span>+971 58 206 0373 </span></a></p>
                                        </div>
                                    </div>

                                </div>

                                {/* <!--=======  End of single contact  =======-->
                                <!--=======  single contact  =======--> */}

                                <div className="single-contact d-flex flex-row-reverse">
                                    <div className="icon">
                                        {/* <span className="icon_mail_alt"></span> */}
                                        <AiOutlineMail />
                                    </div>
                                    <div className="directionRtl">
                                        <div className="contact-info">

                                            <p>الإيميل:<br/> <a className='RemUnderlineFH' href="mailto:info@ossakbire.com"><span>info@ossakbire.com</span></a></p>
                                        </div>
                                    </div>

                                </div>

                                {/* <!--=======  End of single contact  =======--> */}
                            </div>

                            {/* <!--=======  End of contact segments  =======--> */}



                        </div>

                        {/* <!--=======  End of contact summery  =======--> */}

                    </div>
                </div>
            </div>
        </div>

        {/* <!--=======  End of social contact section  =======--> */}

        {/* <!--=======  footer navigation  =======--> */}

        <div className="footer-navigation-section pt-4 pb-4">
            <div className="container">
                <div className="row flex-row-reverse">
                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-3">
                        <div className="directionRtl">
                            <div className="single-navigation-section">

                               	<a  href="/AR"><img width="200" height="130" src={Logo}  alt="OssaKbire Logo" /></a>
                            </div>

                        </div>
                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-3">
                      
                        <div className="directionRtl">
                            <div className="single-navigation-section">
                                <h3 className="nav-section-title">الموقع</h3>
                                <ul>
                                    <li> <a className='RemUnderlineHF' href="/AR/Shop">المتجر</a></li>
                                    <li> <a className='RemUnderlineHF' href="/AR/Authentication">تسجيل الدخول</a></li>
                                    <li> <a className='RemUnderlineHF' href="/AR/Contact">تواصل معنا</a></li>
                                   
                                </ul>
                            </div>
                        </div>

                    </div>

                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-3 ">

                        {/* <!--=======  single navigation section  =======--> */}
                        <div className="directionRtl">
                            <div className="single-navigation-section">
                                <h3 className="nav-section-title">الفئات</h3>
                                <ul>
                                    <li> <a className='RemUnderlineHF' href="/AR/Category/JALLAB-SYRUP/5">جلاب-شراب</a></li>
                                    <li> <a className='RemUnderlineHF' href="/AR/Category/OLIVES/8">زيتون</a></li>
                                    <li> <a className='RemUnderlineHF' href="/AR/Category/TAHINA/12">طحينة - دبس</a></li>
                                  
                                </ul>
                            </div>
                        </div>

                        {/* <!--=======  End of single navigation section  =======--> */}
                    </div>



                    <div className="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-3">
                        {/* <!--=======  single navigation section  =======--> */}
                        <div className="directionRtl">
                            <div className="single-navigation-section">
                                <h3 className="nav-section-title">الفئات</h3>
                                <ul>
                                    <li> <a className='RemUnderlineHF' href="/AR/Category/PICKLES/10">كبيس</a></li>
                                    <li> <a className='RemUnderlineHF' href="/AR/Category/JAMS/6">مربى</a></li>
                                    <li> <a className='RemUnderlineHF' href="/AR/Category/SUMAC-KESHEK/11">سماق - كشك</a></li>
                                </ul>
                            </div>
                        </div>

                    </div>

                    
                    {/* <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12 mb-xs-30">
                        =======  single navigation section  =======-->
                    <!-- 
                        <div class="single-navigation-section">
                            <h3 class="nav-section-title">CUSTOMER SERVICE</h3>
                            <ul>
                                <li> <a href="contact.html">Contact</a></li>
                                <li> <a href="#">OUR SERVICE</a></li>
                                <li> <a href="#">RETURNS</a></li>
                                <li> <a href="#">SITE MAP</a></li>
                            </ul>
                        </div> -->

                    <!--=======  End of single navigation section  =======-->
                    <!-- </div> --> */}
                    {/* <!-- <div class="col-lg-3 col-md-3 col-sm-6 col-xs-12"> -->
                    <!--=======  single navigation section  =======-->

                    <!-- <div class="single-navigation-section">
                            <h3 class="nav-section-title">Extras</h3>
                            <ul>
                                <li> <a href="contact.html">BRANDS</a></li>
                                <li> <a href="#">GIFT VOUCHERS</a></li>
                                <li> <a href="#">AFFILIATES</a></li>
                                <li> <a href="#">SPECIALS</a></li>
                            </ul>
                        </div> -->

                    <!--=======  End of single navigation section  =======-->
                    <!-- </div> --> */}
                </div>
            </div>
        </div>

        {/* <!--=======  End of footer navigation  =======--> */}


        {/* <!--=======  copyright section  =======--> */}

        <div className="copyright-section pt-3 pb-3">
            <div className="container">
            <div className="footerbottom">
                <p >&copy; 2023 <a target="_blank" href="https://hyveonline.com/">

                    HyveOnline </a>. All rights reserved.</p>


</div>



                {/* <!-- <div class="row align-items-md-center align-items-sm-center flex-row-reverse">
                    <div class="col-lg-4 col-md-6 col-sm-12 col-xs-12 text-center text-md-start"> -->
                        <!--=======  copyright text	  =======-->

                        <!-- <div class="copyright-segment float-sm-end">

                            <p class="footeerParaghraphArabic">
                                <a href="#">سياسة الخصوصية</a>
                                <span class="separator">|</span>
                                <a href="#">الشروط والأحكام</a>
                            </p> -->
                            <!-- <p class="copyright-text">&copy; 2023 <a href="/">

                                    HyveOnline </a>. All rights reserved.</p>
                        </div> -->

                        <!--=======  End of copyright text	  =======-->

                    <!-- </div>
                    <div class="col-lg-8 col-md-6 col-sm-12 col-xs-12"> -->
                        <!--=======  payment info  =======-->

                        <!-- <div class="payment-info text-center text-md-end float-sm-start" >
                            <div class="directionRtl">
                                <p> بإمكانك الدفع من خلال <img width="316" height="44"
                                        src="assets/images/payment-icon.webp" class="img-fluid" alt=""></p>
                            </div>
                        </div> -->

                        <!--=======  End of payment info  =======-->
                  <!-- 
                    </div>
                </div> --> */}
            </div>
        </div>

        {/* <!--=======  End of copyright section  =======--> */}
    </footer>
    </>
  )
}

export default FooterAR